import { useState, useEffect } from "react";
import NavBar from "../../NavBar";
import axios from "axios";
import CouponTable from "./CouponTable";
import "./style.scss";

const MenziesManagement = () => {
  const url = process.env.REACT_APP_DEPPLOYED;
  const [isDisable, setIsDisable] = useState(false);
  const [couponInfo, setCouponInfo] = useState();
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState({
    siteId: null,
    siteName: null,
  });
  const [userData, setUserData] = useState({
    user: null,
    role: null,
  });

  useEffect(async () => {
    let userD = localStorage.getItem("userDetails");
    let user = JSON.parse(userD);
    setUserData((prev) => ({
      ...prev,
      user: user?.user?.user,
      role: user?.user?.role,
    }));
    await axios
      .post(`${url}/eposSQL/getSitesByName`, {
        sites: user.user.sites,
      })
      .then((res) => {
        if (res.data.length === 1) {
          setSelectedSite((prev) => ({
            ...prev,
            siteId: res.data[0].eposId,
            siteName: res.data[0].siteName,
          }));
        } else {
          setSites(res.data);
        }
      })
      .catch((error) => {
        console.log("Error", error);
      });
  }, []);

  useEffect(async () => {
    setIsDisable(true);
    setCouponInfo();
    //get submitted coupons also
    const params = { siteId: selectedSite?.siteId, isWithSubmitted: true };
    await axios
      .post(`${url}/coupons/getEods`, params)
      .then((res) => {
        setCouponInfo(res.data);
        setIsDisable(false);
      })
      .catch((error) => {
        console.log("Fetch error", error);
        setIsDisable(false);
      });
  }, [selectedSite]);

  const handleSiteChange = (e) => {
    const selectedOption = e.target.selectedOptions[0];
    const newSite = {
      siteId: e.target.value,
      siteName: selectedOption.getAttribute("siteName"),
    };
    setSelectedSite((prev) => ({
      ...prev,
      ...newSite,
    }));
  };

  return (
    <>
      <NavBar />

      <div className="main_section">
        <div className="">
          <h1>Menzies oversight</h1>
        </div>
        {sites.length > 1 ? (
          <div className="site-select-container">
            <h2>Select site</h2>
            <select onChange={handleSiteChange} disabled={isDisable}>
              <option>--Select Site--</option>
              {sites.map(function (site, i) {
                return (
                  <option
                    key={site.eposId}
                    value={site.eposId}
                    siteName={site.siteName}
                  >
                    {site.siteName}
                  </option>
                );
              })}
            </select>
          </div>
        ) : (
          <h2>
            Coupons for:{" "}
            <span style={{ color: "#2c53a0" }}>{selectedSite.siteName}</span>
          </h2>
        )}
        {console.log(couponInfo)}
        {couponInfo && <CouponTable couponInfo={couponInfo} url={url} />}
      </div>
    </>
  );
};

export default MenziesManagement;
